import React, { memo } from "react"
import PropTypes from "prop-types"
import { Flex } from "antd"
import { FileDoneOutlined, FileExclamationOutlined } from "@ant-design/icons"
import { WAIVER_STATUS } from "pagesV2/pro/Calendar/shared/bookingTileUtils"
import styles from "./index.module.css"

const ICONS = {
  [WAIVER_STATUS.SIGNED]: <FileDoneOutlined />,
  [WAIVER_STATUS.PENDING]: <FileExclamationOutlined />
}

/**
 * Waiver status pill for calendar booking tiles. Colors are dynamic and come
 * from the booking's own palette (`colors`); the status decides the icon and
 * `label` carries the text (e.g. "Signed" / "2 pending").
 */
const WaiverBadge = ({ status = WAIVER_STATUS.PENDING, label = "", colors = {} }) => {
  const icon = ICONS[status] || ICONS[WAIVER_STATUS.PENDING]
  return (
    <Flex
      align="center"
      gap={4}
      className={styles.badge}
      style={{ borderColor: colors.borderColor, color: colors.textColor || colors.borderColor }}
      title={label}
    >
      <span className={styles.icon} aria-hidden="true">
        {icon}
      </span>
      {label && <span className={styles.label}>{label}</span>}
    </Flex>
  )
}

WaiverBadge.propTypes = {
  status: PropTypes.oneOf([WAIVER_STATUS.SIGNED, WAIVER_STATUS.PENDING]),
  label: PropTypes.string,
  colors: PropTypes.shape({
    backgroundColor: PropTypes.string,
    borderColor: PropTypes.string,
    textColor: PropTypes.string
  })
}

export default memo(WaiverBadge)
